import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ModalModule} from '../modal';
import {OverlayModule} from '../overlay';
import {ScrollbarWithEndingBlindsModule} from '../scrollbar-with-ending-blinds';
import {TooltipModule} from '../tooltip';
import {L10nModule} from '../translate';
import {DropdownMenuComponent} from './dropdown-menu.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        OverlayModule,
        ModalModule,
        TooltipModule,
        ScrollbarWithEndingBlindsModule
    ],
    declarations: [
        DropdownMenuComponent
    ]
})
export class DropdownMenuModule {}
